import { IState } from 'store';

export const getCompaniesListSelector = (state: IState) => state.companiesList.companies;
export const getCompaniesListOptionsSelector = (state: IState) => state.companiesList.options;
